import { servicesUsers } from 'services';
import useMutationHookWrapper, {
    TAsyncStatesHandlers,
} from 'hooks/use-mutation-hook-wrapper';
import { users as typesUsers, network } from 'types';

const useUserUnlock = (
    arg0?: TAsyncStatesHandlers<network.TQueryDefWrapper<null>, string>,
) => {
    return useMutationHookWrapper<
        network.TQueryDefWrapper<null>,
        string,
        typesUsers.TUserIdParams
    >({
        mutationFn: servicesUsers.unlock,
        mutationConfig: {},
        asyncStateHandlers: arg0,
    });
};

export default useUserUnlock;
